module.exports = __webpack_public_path__ + "img/patanjali.00db498b.jpg";